import React from 'react';

import dompurify, { Config } from 'dompurify';

type OwnProps<E extends React.ElementType = React.ElementType> = {
  as?: E;
  children: string;
  config?: Config;
};

type Props<E extends React.ElementType> = OwnProps<E> &
  Omit<React.ComponentProps<E>, keyof OwnProps>;

const defaultElement = 'div';

export const SafeHtmlParser = <E extends React.ElementType = typeof defaultElement>(
  props: Props<E>
): React.ReactElement | null => {
  const { as: Element = defaultElement, children, config, ...restProps } = props;
  const purifiedHtml = dompurify.sanitize(children, config || {}).toString();

  return (
    <Element
      {...restProps}
      // Disable eslint `react/no-danger` rule cause html is sanitized with dompurify to prevent XSS atack
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: purifiedHtml }}
    />
  );
};

export default React.memo(SafeHtmlParser);
